module.exports = __webpack_public_path__ + "static/media/cart.56d44476.svg";